import { FC } from 'react'
import styled from 'styled-components'
import { CoverLetterContentNode, CoverLetterNodeType } from './index'

interface SearchKeywordHighlightNodeProps {
  node?: CoverLetterContentNode
}

export const SearchKeywordHighlightNode: FC<
  SearchKeywordHighlightNodeProps
> = ({ children }) => {
  return <StyledB>{children}</StyledB>
}

const StyledB = styled.b`
  font-weight: 600;
  background-color: #bbe6ff;
`

export function buildSearchKeywordHighlightNode(
  id: string,
  childrenNodeList: CoverLetterContentNode[],
): CoverLetterContentNode {
  return {
    id,
    type: CoverLetterNodeType.COMPONENT,
    wrapper: 'SearchKeywordHighlightNode',
    childrenNodeList,
  }
}
